import { GetGovMapGroupsResponseDto } from '@issuemanager/api-client';
import { TreeViewNode } from '../tree-view-selector';

export function mapDataToTreeViewNode(
  data: GetGovMapGroupsResponseDto[],
): TreeViewNode[] {
  return data.map(({ id, name, parentGroupId, children }) => ({
    id,
    name,
    parentId: parentGroupId,
    children: mapDataToTreeViewNode(children),
  }));
}
